import { CSSProperties } from "react";
import "./styles.sass";
import classNames from "classnames";

type LoyaltySkeletonProps = {
  active?: boolean;
  styles?: CSSProperties;
};

const LoyaltySkeleton = ({ active = false, styles }: LoyaltySkeletonProps) => {
  const classNameSkeleton = classNames(
    "LoyaltySkeleton",
    active && "LoyaltySkeleton_active",
  );

  return <div className={classNameSkeleton} style={styles} />;
};

export default LoyaltySkeleton;
